import { cn } from "@/lib/utils";
import type { ActionBreakdownItem } from "../types";
import { BreakdownItem } from "./BreakdownItem";
import { useLanguage } from "../i18n";

export interface BreakdownListProps {
  breakdown: ActionBreakdownItem[];
  className?: string;
}

export function BreakdownList({ breakdown, className }: BreakdownListProps) {
  const { t } = useLanguage();

  if (breakdown.length === 0) {
    return null;
  }

  return (
    <div className={cn("mt-8 pt-6 border-t border-bb-gray-mid text-left", className)}>
      <h3
        className={cn(
          "font-condensed text-base uppercase tracking-[0.15em]",
          "text-bb-bone-white/60 mb-4"
        )}
      >
        {t.detailByAction}
      </h3>
      <div>
        {breakdown.map((item) => (
          <BreakdownItem key={item.index} item={item} />
        ))}
      </div>
    </div>
  );
}
